import isWeb from './isWeb'

function isDarkMode () {
  if (isWeb) { return false }

  return global.Appearance.getColorScheme() === 'dark'
}

export default isDarkMode
